module.exports = __webpack_public_path__ + "static/media/Access_Options@3x.0688d0d4.png";